import { render, staticRenderFns } from "./SExpandable.vue?vue&type=template&id=5e3d58fd&scoped=true&"
import script from "./SExpandable.vue?vue&type=script&lang=ts&"
export * from "./SExpandable.vue?vue&type=script&lang=ts&"
import style0 from "./SExpandable.vue?vue&type=style&index=0&id=5e3d58fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d58fd",
  null
  
)

export default component.exports